import { render } from "./PartLocation.vue?vue&type=template&id=3480515b&scoped=true"
import script from "./PartLocation.vue?vue&type=script&lang=js"
export * from "./PartLocation.vue?vue&type=script&lang=js"

import "./PartLocation.vue?vue&type=style&index=0&id=3480515b&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3480515b"]])

export default __exports__